export default __webpack_public_path__ + "static/media/settings.d4098613.svg";